import { render, staticRenderFns } from "./sucursalesBarragan.vue?vue&type=template&id=ec4da40a&scoped=true&"
import script from "./sucursalesBarragan.vue?vue&type=script&lang=js&"
export * from "./sucursalesBarragan.vue?vue&type=script&lang=js&"
import style0 from "./sucursalesBarragan.vue?vue&type=style&index=0&id=ec4da40a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec4da40a",
  null
  
)

export default component.exports